@let it = item();
@let lvl = level();
<!-- Une sous-ligne n'a d'icône qu'au rail : sans elle, son libellé masqué
     laissait une ligne vide. Dépliée, elle garde le retrait sans icône. -->

@if (isLink(it) && !isFunction(it.route)) {
  <a
    [fragment]="it.fragment"
    [queryParams]="it.queryParams || null"
    [routerLinkActiveOptions]="it.routerLinkActiveOptions || { exact: false }"
    [routerLink]="it.route"
    class="vex-sidenav-item"
    matRipple
    matRippleColor="var(--vex-sidenav-item-ripple-color)"
    [matTooltip]="translatedLabel()"
    matTooltipPosition="right"
    [matTooltipDisabled]="lvl !== 0 || !labelsHidden()"
    routerLinkActive="vex-sidenav-item--active">
    @if (it.icon && (lvl === 0 || labelsHidden())) {
      <mat-icon
        [svgIcon]="it.icon"
      class="vex-sidenav-item__icon"></mat-icon>
    }
    <span class="vex-sidenav-item__label">{{ translatedLabel() }}</span>
    @if (keyboardShortcutLabel(); as kbd) {
      <kbd class="vex-sidenav-item__shortcut" aria-hidden="true">{{ kbd }}</kbd>
    }
    @if (it.badge; as badge) {
      <span
        [ngClass]="[badge.bgClass, badge.textClass]"
        class="vex-sidenav-item__badge"
        [class.vex-sidenav-item__badge--desktop-only]="badge.desktopOnly"
        >{{ badge.value }}</span
        >
      }
    </a>
  }

  @if (isLink(it) && isFunction(it.route)) {
    <div
      (click)="$any(it.route)(); $event.stopPropagation()"
      (keydown.enter)="$any(it.route)()"
      class="vex-sidenav-item"
      matRipple
      matRippleColor="var(--vex-sidenav-item-ripple-color)"
      [matTooltip]="translatedLabel()"
      matTooltipPosition="right"
      [matTooltipDisabled]="lvl !== 0 || !labelsHidden()"
      [class.vex-sidenav-item--active]="it.isActive ? it.isActive() : false"
      tabindex="0">
      @if (it.icon && (lvl === 0 || labelsHidden())) {
        <mat-icon
          [svgIcon]="it.icon"
        class="vex-sidenav-item__icon"></mat-icon>
      }
      <span class="vex-sidenav-item__label">{{ translatedLabel() }}</span>
      @if (keyboardShortcutLabel(); as kbd) {
        <kbd class="vex-sidenav-item__shortcut" aria-hidden="true">{{ kbd }}</kbd>
      }
      @if (it.badge; as badge) {
        <span
          [ngClass]="[badge.bgClass, badge.textClass]"
          class="vex-sidenav-item__badge"
          [class.vex-sidenav-item__badge--desktop-only]="badge.desktopOnly"
          >{{ badge.value }}</span
          >
        }
      </div>
    }

    @if (isDropdown(it)) {
      <div
        (click)="toggleOpen()" (keydown.enter)="toggleOpen()"
        [class.vex-sidenav-item--active]="isOpen || isActive"
        [class.vex-sidenav-item--open]="isOpen"
        class="vex-sidenav-item"
        matRipple
        matRippleColor="var(--vex-sidenav-item-ripple-color)"
        [matTooltip]="translatedLabel()"
        matTooltipPosition="right"
        [matTooltipDisabled]="lvl !== 0 || !labelsHidden()" tabindex="0">
        @if (it.icon && (lvl === 0 || labelsHidden())) {
          <mat-icon
            [svgIcon]="it.icon"
          class="vex-sidenav-item__icon"></mat-icon>
        }
        <span class="vex-sidenav-item__label">{{ translatedLabel() }}</span>
        @if (it.badge; as badge) {
          <span
            [ngClass]="[badge.bgClass, badge.textClass]"
            class="vex-sidenav-item__badge"
            >{{ badge.value }}</span
            >
          }
          <mat-icon
            class="vex-sidenav-item__dropdown-icon"
          svgIcon="mat:keyboard_arrow_right"></mat-icon>
        </div>
        <div [@dropdown]="isOpen" class="vex-sidenav-item__dropdown">
          @for (subItem of it.children; track subItem) {
            <vex-sidenav-item
              [item]="subItem"
            [level]="lvl + 1"></vex-sidenav-item>
          }
        </div>
      }

      @if (isSubheading(it)) {
        <div class="vex-sidenav-subheading">{{ translatedLabel() }}</div>
        @for (subItem of it.children; track subItem) {
          <vex-sidenav-item
            [item]="subItem"
          [level]="0"></vex-sidenav-item>
        }
      }
